import { HistoryOutlined } from '@mui/icons-material';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useClassicNavigate } from '../../hooks/useClassicNavigate';
import { getConversations } from '../../redux/actions/conversationActions';
import { myFolder } from '../../redux/consts';
import {
  selectAppStatus,
  setDrawerOpen,
  setFolderListOpen,
  setRecentChatsOpen,
} from '../../redux/reducers/appStatusReducer';
import { setSearchQuery } from '../../redux/reducers/navDrawerReducer';
import { AppDispatch } from '../../redux/store';
import { setFocusById } from '../../services/util';
import { StyledDrawerButton } from '../../theme/CustomComponents';
import { AnalyticsEvent, useAnalytics } from '../Providers/AnalyticsProvider';
import ChatList from './ChatList';

const DrawerChatList: React.FC<{ chatListHeight: string }> = ({ chatListHeight }) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useClassicNavigate();
  const analytics = useAnalytics();
  const { drawerOpen } = useSelector(selectAppStatus);

  const handleConversationUpdate = useCallback(
    (conversationId?: string, folderId?: string, shouldFetchConversations = true) => {
      analytics.event(
        AnalyticsEvent.WM_NIGEL_CONVERSATION_CLICK,
        {
          id: conversationId,
        },
        { conversationId }
      );
      if (shouldFetchConversations) {
        dispatch(getConversations({ pageAction: 'reset', searchQuery: '' }));
      }

      dispatch(setSearchQuery(''));

      const route = `/folder/${folderId ?? myFolder.id}`;

      if (conversationId) {
        navigate(`${route}/${conversationId}`);
      } else {
        navigate(route);
      }

      setFocusById('chat-input');
    },
    [analytics, dispatch, navigate]
  );

  return (
    <>
      {drawerOpen ? (
        <div id="chat-list">
          <ChatList
            onConversationUpdated={handleConversationUpdate}
            chatListHeight={chatListHeight}
          />
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            padding: '5px 0px',
            alignItems: drawerOpen ? 'stretch' : 'center',
          }}
        >
          <StyledDrawerButton
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={() => {
              dispatch(setFolderListOpen(false));
              dispatch(setRecentChatsOpen(true));
              dispatch(setDrawerOpen(true));
            }}
          >
            <HistoryOutlined sx={{ height: '20px', width: '20px', color: '#070154' }} />
          </StyledDrawerButton>
        </div>
      )}
    </>
  );
};

export default DrawerChatList;
